import React, { Component } from 'react'
import Spinner from '../../../Spinner'

export default class Neighbordhood extends Component {
  constructor (props) {
    super(props)
    this.state = {
      places: [],
      show: false
    }
  }

  componentDidMount(){
    this.findPlaces(this.props.lat, this.props.lng)
  }

  findPlaces(lat, lng){
    var placeLocation = new google.maps.LatLng(lat, lng);

    const consultas = [
      {name: 'Subtes', icon: 'fa fa-subway fa-lg', type: 'subway_station'},
      {name: 'Trenes', icon: 'fa fa-train fa-lg', type: 'train_station'},
      {name: 'Micros', icon: 'fa fa-bus fa-lg', type: 'bus_station'},
      {name: 'Universidades', icon: 'fa fa-university fa-lg', type: 'university'},
      {name: 'Hospitales', icon: 'fa fa-hospital-o fa-lg', type: 'hospital'},
      {name: 'Shoppings', icon: 'fa fa-shopping-bag fa-lg', type: 'shopping_mall'},
      {name: 'Aeropuertos', icon: 'fa fa-plane fa-lg', type: 'airport'},
    ];

    var container = this.refs.results;
    let service = new google.maps.places.PlacesService(container);

    const promises = consultas.map((consulta) =>
      new Promise((resolve) => {
        service.nearbySearch({location: placeLocation, radius: '500', types: [`${consulta.type}`]}, function(results, status) {
            if (status === 'OK'){
              resolve({name: `${consulta.name}`, cant: results.length, icon: `${consulta.icon}`})
            }else{
              resolve([])
            }
        });
      }),
    )

    Promise.all(promises).then((params) => {
      this.setState({
        places: [].concat(...params),
        show: true
      })
    }, error => console.error);

  }

  render(){
      return(
        <div>
            { this.state.show ? <h1> Características de la zona </h1> : null }
            <div className="column-zone">
              {this.state.places.map((item, index) =>
                <div key={index}>
                  <div className="zone-info hidden-xs" >
                    <i className={item.icon}></i>
                    <p>{item.cant}</p>
                    <p>{item.name}</p>
                  </div>
                  <div className="zone-info visible-xs">
                    <i className={item.icon}></i>
                    <p>{item.cant}</p>
                  </div>
                </div>
              )}
            </div>
            <div ref="results"></div>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/neighbordhood.js